import { AppEnv } from './enums';

export const CW_APP_SOURCE = 'CW';
export const GDPR_SETTINGS = 'cw-gdpr-settings';
export const LEGAL_BASE_URL = import.meta.env.VITE_LANDING_URL;
export const COOKIE_PATH = `${LEGAL_BASE_URL}/cookie-policy`;
export const EMPLOYERS_PATH = `${LEGAL_BASE_URL}/employers`;
export const PRODUCTION_URL = 'employer.joblio.co';

export const CLIENT_FORM_ID = 'employer-form';

export const APP_CURRENCY_SYMBOL = import.meta.env.VITE_APP_CURRENCY_SYMBOL;

export const MAX_OFFER_LETTER_FILE_SIZE_MB = 10;

export const GOOGLE_PRIVACY_POLICY_URL = 'https://policies.google.com/privacy';
export const GOOGLE_TERMS_OF_SERVICE_URL = 'https://policies.google.com/terms';

export const TEST_RECAPTCHA_TOKEN = 'test-env-captcha-token';
export const CAPTCHA_ENABLED_ENVS: AppEnv[] = [AppEnv.Stage, AppEnv.Prod];
